import { render, staticRenderFns } from "./DataCardItem.vue?vue&type=template&id=5f144a23&scoped=true&"
import script from "./DataCardItem.vue?vue&type=script&lang=js&"
export * from "./DataCardItem.vue?vue&type=script&lang=js&"
import style0 from "./DataCardItem.vue?vue&type=style&index=0&id=5f144a23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f144a23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f144a23')) {
      api.createRecord('5f144a23', component.options)
    } else {
      api.reload('5f144a23', component.options)
    }
    module.hot.accept("./DataCardItem.vue?vue&type=template&id=5f144a23&scoped=true&", function () {
      api.rerender('5f144a23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/submit-application/components/DataCardItem.vue"
export default component.exports